// import { TransactionStats } from '@/types';
// import { Box, CircularProgress, Typography } from '@mui/material';
// import React from 'react';
// import {
//     Bar,
//     BarChart,
//     CartesianGrid,
//     Legend,
//     ResponsiveContainer,
//     Tooltip,
//     XAxis,
//     YAxis,
// } from 'recharts';

// interface MerchantTransactionStatsChartProps {
//     data?: TransactionStats[];
//     loading?: boolean;
// }

// const MerchantTransactionStatsChart: React.FC<
//     MerchantTransactionStatsChartProps
// > = ({ data, loading }) => {
//     if (loading)
//         return (
//             <Box
//                 display="flex"
//                 justifyContent="center"
//                 alignItems="center"
//                 height={200}
//             >
//                 <CircularProgress />
//             </Box>
//         );

//     if (!data?.length)
//         return (
//             <Typography
//                 textAlign="center"
//                 variant="body2"
//                 color="textSecondary"
//             >
//                 No transaction data available for this period.
//             </Typography>
//         );

//     // 🗓️ Format date helper
//     const formatDate = (dateString: string) => {
//         const date = new Date(dateString);
//         return date.toLocaleDateString('en-US', {
//             month: 'short', // e.g. Oct
//             day: 'numeric', // e.g. 17
//             year: 'numeric', // e.g. 2025
//         });
//     };
//     // Convert numeric fields to numbers for recharts
//     const formattedData = data.map(d => ({
//         ...d,
//         week_start: formatDate(d.week_start),
//         total_transactions: Number(d.total_transactions),
//         total_chargeback: Number(d.total_chargeback),
//     }));

//     return (
//         <Box sx={{ width: '100%', height: 350 }}>
//             <Typography
//                 variant="h6"
//                 sx={{ textAlign: 'center', fontWeight: 'bold', mb: 2 }}
//             >
//                 Weekly Transaction vs Chargeback Stats
//             </Typography>

//             <ResponsiveContainer width="100%" height="100%">
//                 <BarChart
//                     data={formattedData}
//                     margin={{ top: 10, right: 20, left: 0, bottom: 10 }}
//                 >
//                     <CartesianGrid strokeDasharray="3 3" />
//                     <XAxis dataKey="week_start" />
//                     <YAxis />
//                     <Tooltip />
//                     <Legend />
//                     <Bar
//                         dataKey="total_transactions"
//                         fill="#1976d2"
//                         name="Transactions"
//                         barSize={40}
//                     />
//                     <Bar
//                         dataKey="total_chargeback"
//                         fill="#d32f2f"
//                         name="Chargebacks"
//                         barSize={40}
//                     />
//                 </BarChart>
//             </ResponsiveContainer>
//         </Box>
//     );
// };

// export default MerchantTransactionStatsChart;

import { TransactionStats } from '@/types';
import { Box, CircularProgress, Typography } from '@mui/material';
import React from 'react';
import {
    Line,
    LineChart,
    CartesianGrid,
    Legend,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis,
} from 'recharts';

interface MerchantTransactionStatsChartProps {
    data?: TransactionStats[];
    loading?: boolean;
}

const MerchantTransactionStatsChart: React.FC<
    MerchantTransactionStatsChartProps
> = ({ data, loading }) => {
    if (loading)
        return (
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height={200}
            >
                <CircularProgress />
            </Box>
        );

    if (!data?.length)
        return (
            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <Typography
                    textAlign="center"
                    variant="body2"
                    color="textSecondary"
                >
                    No transaction data available for this period.
                </Typography>
            </Box>
        );

    console.log(data, 'dattata');
    // 🗓️ Format date helper
    const formatDate = (dateString: string) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            month: 'short', // e.g. Oct
            day: 'numeric', // e.g. 17
            year: 'numeric', // e.g. 2025
        });
    };

    // Convert numeric fields to numbers for recharts
    const formattedData = data.map(d => ({
        ...d,
        week_start: formatDate(d.week_start),
        total_transactions: Number(d.total_transactions),
        total_chargeback: Number(d.total_chargeback),
    }));

    return (
        <Box sx={{ width: '100%', height: 350 }}>
            <Typography
                variant="h6"
                sx={{ textAlign: 'center', fontWeight: 'bold', mb: 2 }}
            >
                Weekly Transaction vs Chargeback Stats
            </Typography>

            <ResponsiveContainer width="100%" height="100%">
                <LineChart
                    data={formattedData}
                    margin={{ top: 10, right: 20, left: 0, bottom: 10 }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="week_start" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Line
                        type="monotone"
                        dataKey="total_transactions"
                        stroke="#1976d2"
                        name="Transactions"
                        strokeWidth={2}
                    />
                    <Line
                        type="monotone"
                        dataKey="total_chargeback"
                        stroke="#d32f2f"
                        name="Chargebacks"
                        strokeWidth={2}
                    />
                </LineChart>
            </ResponsiveContainer>
        </Box>
    );
};

export default MerchantTransactionStatsChart;
